/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterDetail } from '../../models/work-center-detail';

export interface GetWorkCenterDetail$Params {
  workCenterId: number;
}

export function getWorkCenterDetail(http: HttpClient, rootUrl: string, params: GetWorkCenterDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkCenterDetail>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterDetail.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkCenterDetail>;
    })
  );
}

getWorkCenterDetail.PATH = '/api/v1/WorkCenter/{workCenterId}/detail';
